import * as React from 'react';
import '../sass/UserNavMenu.css';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import '../sass/LeaderboardComponent.css';
import { db } from '../firebase/firebase';
import Leaderboard from './Leaderboard';


// interface leaderboardData {
//     name:string;
//     score:number;
// }

export default class LeaderboardComponent extends React.Component<any, any> {
    
    // private leaderboardDatabaseRef:firebase.database.Reference = db.app.database().ref('scoreboard');

    constructor(props:any) {
        super(props);

        this.state = {
        }
    }

    render() {
        return (
            <div id='leaderboardContainer' className='pageContainer'>
                <h2 className="pageHeader">Leaderboard</h2>
                <Leaderboard settings={this.props.settings} userData={this.props.userData} leaderboardDatabaseRef={this.props.leaderboardDatabaseRef}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LeaderboardComponent.tsx